import { useEffect, useState } from 'react';
import { connect } from 'react-redux';
import { Link, useParams } from 'react-router-dom';
import { SiteAction } from '../../actions/SiteAction';
import { Flag } from '../../components/common/CommonViews';
import { NoRecord } from '../HomePage';
import { Translate as t } from '../../config/Translate';
import { history } from '../../history';
import AdminSiteDelete from './AdminSiteDelete';
import AdminSiteInfo_Customer from './AdminSiteInfo_Customer';
import AdminSiteInfo_Product from './AdminSiteInfo_Product';
import AdminSiteInfoSummary from './AdminSiteInfoSummary';

const AdminSiteEdit = ({ site, GetSite }) => {

    const { id, view } = useParams();
    const [editable, setEditable] = useState(false);
    const [tab, setTab] = useState(view || "siteinfo");

    useEffect(() => {
        setTab(view || "siteinfo")
    }, [view])

    // U-27: 조회가 끝났는데도 주소의 사이트와 일치하지 않으면 Loading 대신 "없음" 안내.
    const [fetchDone, setFetchDone] = useState(false);
    const matched = !!id && String(id) === String(site?._id ?? '');

    useEffect(() => {
        let alive = true;
        setFetchDone(false);
        if (matched) {
            setFetchDone(true);
            return undefined;
        }
        // thunk 는 내부 try/catch 로 처리하므로 여기 catch 는 unhandled rejection 차단용.
        Promise.resolve(GetSite(id)).catch(() => { }).finally(() => {
            if (alive) setFetchDone(true);
        });
        return () => { alive = false; };
    }, [id])

    const tabList = [
        { code: "siteinfo", title: `${t('site.title')} ${t('common.label.information')}` },
        { code: "customerinfo", title: `${t('common.label.customer')} ${t('common.label.information')}` },
        { code: "product", title: t('common.status.installed') },
    ]

    const createService = () => {
        history.push({
            pathname: '/Admin/AdminServiceAdd',
            state: {
                refer: 'SITENORMAL',
                item: {},
                extraItem: site,
            },
        });
    }

    return (
        <>
            {!matched && !fetchDone && <div className="">Loading...</div>}
            {!matched && fetchDone &&
                <div className="section mt-2 mb-2">
                    <NoRecord />
                    <Link to="/Admin/AdminSiteList" className="btn btn-sm mt-1">
                        <ion-icon name="list-outline"></ion-icon> {t('common.label.list')}
                    </Link>
                </div>
            }
            {matched &&
                <>
                    <div className="extraHeader">
                        <h2 className="mb-0">{Flag(site.country, 42)}{id ? site.sitename : "Add New Site"}</h2>
                        <div className="ray-right">
                            {(tab == "siteinfo" || tab == "customerinfo") &&
                                <a href onClick={() => setEditable(!editable)} className="btn btn-secondary btn-sm mt-0 me-1">
                                    <ion-icon name={editable ? "lock-open-outline" : "lock-closed-outline"} />
                                    {editable ? t('common.status.unlocked') : t('common.status.locked')}
                                </a>
                            }
                            <Link to={"/Admin/AdminSiteInfo/" + site._id + "/del"} className="btn btn-danger btn-sm mt-0 me-1" onClick={() => setTab('del')}>{t('site.button.deleteSite')}</Link>
                            <Link to="/Admin/AdminSiteDashboard" className="btn btn-sm mt-0">
                                <ion-icon name="desktop-outline"></ion-icon> {t('dashboard.title')}
                            </Link>
                            <Link to="/Admin/AdminSiteList" className="btn btn-sm mt-0">
                                <ion-icon name="list-outline"></ion-icon> {t('common.label.list')}
                            </Link>
                        </div>
                    </div>
                    <div id="appCapsule" className="extra-header-active full-height">
                        <div className="section mt-1 mb-1">
                            <ul className="nav nav-tabs style2 mt-1 mb-1">
                                {tabList.map(x => {
                                    return (
                                        <li className="nav-item" key={x.code}>
                                            <Link to={"/Admin/AdminSiteInfo/" + site._id + "/" + x.code}
                                                className={tab == x.code ? "nav-link active" : "nav-link"}
                                                onClick={() => setTab(x.code)}>{x.title}</Link>
                                        </li>
                                    )
                                })}
                            </ul>
                        </div>
                        {tab == "siteinfo" && <AdminSiteInfoSummary site={site} editable={editable} cancelcallback={() => setEditable(false)} />}
                        {tab == "customerinfo" && <AdminSiteInfo_Customer site={site} editable={editable} cancelcallback={() => setEditable(false)} />}
                        {tab == "product" && <AdminSiteInfo_Product site={site} />}
                        {tab == "del" && <AdminSiteDelete site={site} />}
                    </div>
                </>
            }
        </>
    );
};

const mapState = (state) => {
    const site = state.SiteReducer.site;
    const isClose = state.AlertReducer.isClose;
    return { site, isClose };
}

const mapDispatch = dispatch => ({
    GetSite: (_id) => dispatch(SiteAction.GetSite(_id)),
    UpdateSiteInfo: (_id, data) => dispatch(SiteAction.UpdateSiteInfo(_id, data)),
    AddSite: (site) => dispatch(SiteAction.AddSite(site)),
})
export default connect(mapState, mapDispatch)(AdminSiteEdit);
